import { AU1_TEST1_HOSTS } from '@fleet/environment';
import { FLEET_VERSION } from '@fleet/version';

export const environment = {
  production: true,
  hmr: false,
  version: FLEET_VERSION,
  minTokenExpiry: 60,
  fleetProduct: 'TRAVELLER',
  envName: 'test1-au1',

  ...AU1_TEST1_HOSTS,
};
